import React from 'react';
import { motion } from 'framer-motion';
import { FiClock, FiX } from 'react-icons/fi';
import './RecentSearches.css';

/**
 * Recent searches component showing search history
 */
const RecentSearches = ({ searches, onSelect, onRemove }) => {
  // Format relative time
  const getTimeAgo = (timestamp) => {
    const now = Date.now();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    return `${days}d ago`;
  };

  return (
    <motion.div
      className="recent-searches"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="recent-header">
        <FiClock />
        <h3>Recent Searches</h3>
      </div>

      <div className="recent-list">
        {searches.map((search, index) => (
          <motion.div
            key={search.uuid || search.username}
            className="recent-item"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.05 }}
            onClick={() => onSelect(search.username)}
          >
            <img
              src={`https://crafatar.com/avatars/${search.uuid}?size=40&overlay=true`}
              alt={search.username}
              className="recent-avatar"
              onError={(e) => {
                e.target.src = `https://crafatar.com/avatars/8667ba71b85a4004af54457a9734eed7?size=40&overlay=true`;
              }}
            />

            <div className="recent-info">
              <span className="recent-username">{search.username}</span>
              <span className="recent-time">{getTimeAgo(search.timestamp)}</span>
            </div>

            <motion.button
              className="recent-remove"
              onClick={(e) => {
                e.stopPropagation();
                onRemove(search.username);
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <FiX />
            </motion.button>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default RecentSearches;
